<footer *ngIf="showInviteColleague" class="invite">
    <h4>Collega uitnodigen</h4>
    <span *ngIf="itemType === itemTypeEnum.Trainingen"
        >Wil je een collega attenderen op deze training? Stuur hem/haar een email. Hij/zij kan zichzelf dan aanmelden.
        Voor deze training kunnen maximaal {{ valueMap?.get('maxInvitees') }} van je collega’s zich aanmelden.
    </span>
    <span *ngIf="itemType === itemTypeEnum.KennisCafe"
        >Wil je een collega attenderen op dit kenniscafé? Stuur hem/haar een email. Hij/zij kan zichzelf dan aanmelden.
        Voor dit kenniscafé kunnen maximaal {{ valueMap?.get('maxInvitees') }} van je collega’s zich aanmelden.
    </span>
    <app-button [style]="ButtonType.OUTLINED_SECONDARY" (click)="shareWithColleague()"
        >Deel <fa-icon [icon]="faArrowRight"></fa-icon
    ></app-button>
</footer>
<footer [ngClass]="getContactStyle()" *ngIf="showContact && itemType === itemTypeEnum.Trainingen">
    <h4>Heb je vragen over een training?</h4>
    <app-button [style]="ButtonType.OUTLINED_SECONDARY" (click)="openMail()"
        >{{ contactEmail }}<fa-icon [icon]="faEnvelope"></fa-icon
    ></app-button>
</footer>
<footer [ngClass]="getContactStyle()" *ngIf="showContact && itemType === itemTypeEnum.KennisCafe">
    <h4>Heb je vragen over een kenniscafé?</h4>
    <app-button [style]="ButtonType.OUTLINED_SECONDARY" (click)="openMail()"
        >{{ contactEmail }}<fa-icon [icon]="faEnvelope"></fa-icon
    ></app-button>
</footer>
<footer class="view-all" *ngIf="showAllEventsButton && itemType === itemTypeEnum.Trainingen">
    <app-button [style]="ButtonType.OUTLINED_TERTIARY" [routerLink]="'/trainingen'">Bekijk alle trainingen</app-button>
    <app-button [style]="ButtonType.OUTLINED_TERTIARY" *ngIf="itemId" [routerLink]="'/trainingen/detail/' + itemId"
        >Bekijk alle locaties van deze training</app-button
    >
</footer>
<footer class="view-all" *ngIf="showAllEventsButton && itemType === itemTypeEnum.KennisCafe">
    <app-button [style]="ButtonType.OUTLINED_TERTIARY" [routerLink]="'/kenniscafe'">Bekijk alle kenniscafés</app-button>
</footer>
|